//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        show_share: {
            type: Boolean,
            default: true
        },
        show_save_img : {
            type: Boolean,
            default: true
        },
        show_layout: {
            type: Boolean,
            default: false
        },
        show_change_style: {
            type: Boolean,
            default: false
        }
    }
}
